// This component fetches the comment list from appslice.wkf in Redux store and renders it.

import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Grid, Typography, IconButton, Dialog, DialogTitle, DialogContent, Box, TextField, DialogActions, Button, Divider, DialogContentText, RadioGroup, FormControlLabel, Radio, CircularProgress, MenuItem, Select, InputLabel, FormControl } from '@mui/material';
import AddCommentIcon from '@mui/icons-material/AddComment';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { addCommentAPI, editCommentAPI, deleteCommentAPI, updateCommentStatusAPI } from "api/CorePlatformserviceWebServices";
import { callGetAPI } from "api/ApiUtils"; // Add this import
import { addCommentObj, updateCommentObj, deleteCommentObj, setCommentList} from "store/slice/AppSlice";
import { extractStringBeforeAtTheRate, transformDateValue } from "core/js/FormUtils";
import { setTaskApiResponseError } from "store/slice/AppSlice";



export default function CommentMgmt(maxHeight, status) {
    const dispatch = useDispatch();
    const { enableAddComment, selectedTaskObj } = useSelector(state => state.appslice.wkflow);
    const { myBusinessUserList } = useSelector(state => state.headerslice);
    const { productObj } = useSelector(state => state.pharmaslice.productDashboard);
    const { userprofileInfo } = useSelector(state => state.headerslice);
    const { taskApiResponse } = useSelector((state) => state.appslice.wkflow);

    const [dialogOpen, setDialogOpen] = useState(false);
    const [newComment, setNewComment] = useState("");
    const [apiError, setApiError] = useState(""); // <-- Add error state
    const [sortedComments, setSortedComments] = useState([]);
    const [editDialogOpen, setEditDialogOpen] = useState(false);
    const [editComment, setEditComment] = useState("");
    const [editCommentId, setEditCommentId] = useState(null);
    const [editApiError, setEditApiError] = useState("");
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [deleteCommentId, setDeleteCommentId] = useState(null);
    const [deleteApiError, setDeleteApiError] = useState("");
    //const [commentList, setCommentList] = useState([]);
    const [isLoadingComments, setIsLoadingComments] = useState(false); // Add loading state
    const {commentList} = useSelector(state => state.appslice.wkflow);
    
    // New state for recipient selection
    const [recipient, setRecipient] = useState('everyone');
    const [editRecipient, setEditRecipient] = useState('everyone');

    // New state for radio filter
    const [commentFilter, setCommentFilter] = useState('all'); // 'all' or 'toMe'

    useEffect(() => {
        if (productObj && productObj.id) {
            setIsLoadingComments(true); // Start loading
            // Call GET API to fetch comments for this product
            const token = localStorage.getItem("JWT");
            callGetAPI(
                `https://api.platform.appmachine.in/comments/boid/${productObj.id}/boobjid`,
                () => { }, // onStart callback
                (response) => {
                    // Success callback - set comment list from response
                    //setCommentList(response.list || response || []);
                    dispatch(setCommentList(response.list || response || []));
                    setIsLoadingComments(false); // Stop loading
                },
                (error) => {
                    // Error callback
                    console.error("Error fetching comments:", error);
                    dispatch(setCommentList([]));
                    setIsLoadingComments(false); // Stop loading
                }
            );
        }
    }, [productObj]);

    useEffect(() => {

    }, [taskApiResponse]);



    useEffect(() => {
        // Sort comments by id in descending order, latest first
        if (commentList && commentList.length > 0) {
            const sorted = [...commentList].sort((a, b) => b.id - a.id);
            setSortedComments(sorted);
        } else {
            setSortedComments([]);
        }
    }, [commentList]);

    // Filtered comments based on radio selection
    const filteredComments = sortedComments.filter(comment => {
        if (commentFilter === 'all') {
            // Show all comments when "All" is selected
            return true;
        }
        // 'toMe'
        return comment.recipientid === userprofileInfo.userid;
    });

    const getCommentAuthorName = (comment) => {
        if (comment.createdby === userprofileInfo.userid) return { name: 'You', role: userprofileInfo.rolename };
        const user = myBusinessUserList.find(user => user.userid === comment.createdby);
        return user ? { name: user.username, role: user.rolename } : { name: comment.author, role: '' }
    };
    const UserNameByUserId = (userid) => {
        if (userid === userprofileInfo.userid) return 'You';
        const user = myBusinessUserList.find(user => user.userid === userid);
        return user ? user.username : 'Everyone';
    };

    const handleAddCommentClick = () => {
        dispatch(setTaskApiResponseError(null));
        setDialogOpen(true)
    };
    const handleDialogClose = () => {
        setDialogOpen(false);
        setNewComment("");
    };
    const handleCommentChange = (e) => setNewComment(e.target.value);

    // You can add your submit logic here
    const handleCommentSubmit = () => {
        dispatch(setTaskApiResponseError(null));
        setApiError(""); // Clear previous error
        const payload = {
            "taskInstanceId": selectedTaskObj.id,
            "comment": newComment,
            "rootId": productObj.orderid,
            "recipientId": recipient === 'everyone' ? 0 : recipient // Add recipient to payload
        };
        addCommentAPI(
            payload,
            (response) => {
                dispatch(addCommentObj(response.commentInfo));
                handleDialogClose();
            },
            (error) => {
                setApiError("Failed to add comment. Please try again."); // Show error
            }
        );
    };

    // Open edit dialog and load comment
    const handleEditClick = (comment) => {
        setEditComment(comment.title || comment.comment || "");
        setEditCommentId(comment.id);
        setEditApiError("");
        setEditRecipient(
            comment.recipientid === 0 || comment.recipientid === undefined
                ? 'everyone'
                : comment.recipientid
        );
        setEditDialogOpen(true);
    };

    const handleEditDialogClose = () => {
        setEditDialogOpen(false);
        setEditComment("");
        setEditCommentId(null);
        setEditApiError("");
    };

    const handleEditCommentChange = (e) => {
        if (e.target.value.length <= 255) setEditComment(e.target.value);
    };

    const handleEditRecipientChange = (e) => setEditRecipient(e.target.value);

    const handleEditCommentSave = () => {
        setEditApiError("");
        const payload = {
            commentId: editCommentId,
            comment: editComment,
            recipientId: editRecipient === 'everyone' ? 0 : editRecipient // Add recipient to payload
        };
        editCommentAPI(
            payload,
            (response) => {
                dispatch(updateCommentObj(response.commentInfo));
                handleEditDialogClose();
            },
            (error) => {
                setEditApiError(error);
            }
        );
    };

    // Open delete confirmation dialog
    const handleDeleteClick = (comment) => {
        setDeleteCommentId(comment.id);
        setDeleteApiError("");
        setDeleteDialogOpen(true);
    };

    const handleDeleteDialogClose = () => {
        setDeleteDialogOpen(false);
        setDeleteCommentId(null);
        setDeleteApiError("");
    };

    const handleDeleteCommentConfirm = () => {
        setDeleteApiError("");
        deleteCommentAPI(
            { commentId: deleteCommentId },
            (response) => {
                dispatch(deleteCommentObj(deleteCommentId));
                handleDeleteDialogClose();
            },
            (error) => {
                setDeleteApiError("Failed to delete comment. Please try again.");
            }
        );
    };
    const updateCommentStatus = (commentId, status) => {
        dispatch(setTaskApiResponseError(null));
        const payload = {
            commentId: commentId,
            statusId: status
        };
        updateCommentStatusAPI(
            payload,
            (response) => {
                dispatch(updateCommentObj(response.commentInfo));
            },
            (error) => {
                console.error("Failed to update comment status:", error);
            }
        );
    };
    const handleRecipientChange = (e) => setRecipient(e.target.value);

    return (
        <Grid container sx={{}}>
            <Grid item xs={12} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between',p: 1 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <Typography variant="h6" color="primary.darker">
                        Comments ({isLoadingComments ? '...' : (commentList ? commentList.length : '')})
                    </Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, backgroundColor: 'secondary.100', borderRadius: 2, p: 1 }}>
                    {/* Radio filter moved here */}
                    <RadioGroup
                        row
                        value={commentFilter}
                        onChange={e => setCommentFilter(e.target.value)}
                        sx={{ mr: 2 }}
                    >
                        <FormControlLabel value="all" control={<Radio size="small" />} label="All" />
                        <FormControlLabel value="toMe" control={<Radio size="small" />} label="To Me" />
                    </RadioGroup>
                </Box>
                <Box
                    sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    {enableAddComment && selectedTaskObj.id!==undefined && (
                        <IconButton color="primary" title="Add Comment" onClick={handleAddCommentClick}>
                            <AddCommentIcon />
                        </IconButton>
                    )}
                </Box>  
            </Grid>
            <Grid item xs={12} sx={{ borderRadius: 2, maxHeight: maxHeight, overflowY: 'auto', }}>
                {isLoadingComments ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 100, backgroundColor: 'white', borderRadius: 1 }}>
                        <CircularProgress size={32} />
                        <Typography variant="body2" color="text.secondary" sx={{ ml: 2 }}>
                            Loading comments...
                        </Typography>
                    </Box>
                ) : filteredComments && filteredComments.length > 0 ? (
                    <Grid container sx={{ width: '100%' }} alignItems="flex-start">
                        {filteredComments.map((comment, idx) => {
                            const profile = getCommentAuthorName(comment);
                            let displayRole = '';
                            if (profile.role) {
                                const parts = profile.role.split('_');
                                displayRole = parts[parts.length - 1];
                            }
                            return (
                                <Grid item lg={12} key={comment.id || idx} sx={{ mb: 1, backgroundColor: 'secondary.100', borderRadius: 1, p: 1 }}>
                                    <Grid container direction="row" alignItems='flex-start' justifyContent='space-between' sx={{}}>
                                        <Grid item lg={4} sx={{ }}>
                                            <Box sx={{ borderRadius: 2, }}>
                                                <Typography variant="h5" sx={{ fontWeight: 600 }}>
                                                    {extractStringBeforeAtTheRate(profile.name)}
                                                </Typography>
                                                {/* <Typography variant="caption" sx={{  }}>
                                                    {displayRole ? `${displayRole}` : ''}
                                                </Typography> */}
                                                <Typography variant="caption" color="text.secondary" sx={{ display: 'block',  }}>
                                                    {comment.creationTimestamp
                                                        ? transformDateValue(comment.creationTimestamp)
                                                        : ''}
                                                </Typography>
                                                <Typography variant="caption" color="text.secondary" sx={{ color:'primary.main', display: 'block', mt: 1, }}>
                                                    TO : {UserNameByUserId(comment.recipientid)}
                                                </Typography>
                                            </Box>
                                        </Grid>
                                        <Grid item lg={8} sx={{ display: 'flex', alignItems: 'flex-start', backgroundColor: 'white', borderRadius: 2, padding: 1, mt: 1 }}>
                                            <Grid container direction="row" sx={{ width: '100%' }}>
                                                <Grid item lg={11}>
                                                    <Box sx={{ alignItems: 'flex-start', ml: 1, width: '100%' }}>
                                                        <Typography
                                                            variant="h6"
                                                            sx={{
                                                                fontWeight: 200,
                                                                wordBreak: 'break-word',
                                                                color: 'primary.darker',

                                                                whiteSpace: 'pre-line'
                                                            }}
                                                        >
                                                            {comment.title}
                                                        </Typography>
                                                    </Box>
                                                </Grid>
                                                <Grid item lg={1}>
                                                    {(comment.commentstatus === 1 && comment.createdby === userprofileInfo.userid) && !taskApiResponse && (
                                                        <Box sx={{}}>
                                                            <IconButton size="small" color="primary" onClick={() => handleEditClick(comment)}>
                                                                <EditIcon fontSize="small" />
                                                            </IconButton>
                                                            <IconButton size="small" color="error" onClick={() => handleDeleteClick(comment)}>
                                                                <DeleteIcon fontSize="small" />
                                                            </IconButton>
                                                        </Box>
                                                    )}
                                                    {(comment.commentstatus === 2) && (
                                                        <Box sx={{}}>
                                                            <IconButton size="small" color="success" >
                                                                <CheckCircleIcon fontSize="small" />
                                                            </IconButton>

                                                        </Box>
                                                    )}
                                                    {(comment.commentstatus === 3) && (
                                                        <Box sx={{}}>
                                                            <IconButton size="small" >
                                                                <CheckCircleIcon fontSize="small" sx={{ color: "secondary" }} />
                                                            </IconButton>

                                                        </Box>
                                                    )}
                                                </Grid>

                                            </Grid>


                                        </Grid>
                                    </Grid>
                                    {comment.resolutiontaskid === selectedTaskObj.taskid && comment.commentstatus === 1 && (
                                        <Grid container sx={{ width: '100%', borderRadius: 1, }}>
                                            <Grid item lg={12}>
                                                {/* Radio button to ask whether resolved or not */}
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                                    <Typography variant="body2" sx={{ mr: 2 }}>
                                                        Is this comment resolved?
                                                    </Typography>
                                                    <RadioGroup
                                                        row
                                                        name={`resolved-radio-${comment.id}`}
                                                        value={comment.commentstatus}
                                                        onChange={e => updateCommentStatus(comment.id, e.target.value)}
                                                    >
                                                        <FormControlLabel value="2" control={<Radio color="success" />} label="Yes" />
                                                        <FormControlLabel value="1" control={<Radio color="error" />} label="No" />
                                                    </RadioGroup>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    )}
                                </Grid>
                            );
                        })}
                    </Grid>
                ) : (
                    <Typography variant="body2" color="text.secondary" sx={{ backgroundColor: 'white', borderRadius: 1 }}>
                        No comments added, so far.
                    </Typography>
                )}
            </Grid>
            <Dialog open={dialogOpen} onClose={handleDialogClose} maxWidth="sm" fullWidth>
                <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pr: 1 }}>
                    Add Comment
                    <IconButton
                        aria-label="close"
                        onClick={handleDialogClose}
                        sx={{
                            color: (theme) => theme.palette.grey[500],
                            ml: 2,
                        }}
                        size="small"
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <Divider />
                <DialogContent>
                    {/* Recipient Dropdown */}
                    <FormControl fullWidth sx={{ mb: 2 }}>
                        <InputLabel id="recipient-label">Recipient</InputLabel>
                        <Select
                            labelId="recipient-label"
                            value={recipient}
                            label="Recipient"
                            onChange={handleRecipientChange}
                        >
                            <MenuItem value="everyone">Everyone</MenuItem>
                            {myBusinessUserList.map(user => (
                                <MenuItem key={user.userid} value={user.userid}>
                                    {user.username} ({user.rolename})
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <TextField
                        autoFocus
                        margin="dense"
                        label="Enter your comment"
                        type="text"
                        fullWidth
                        multiline
                        minRows={3}
                        value={newComment}
                        onChange={e => {
                            if (e.target.value.length <= 255) setNewComment(e.target.value);
                        }}
                        inputProps={{ maxLength: 255 }}
                    />
                    <Typography variant="caption" color="text.secondary" sx={{ float: 'right', mt: 0.5 }}>
                        {newComment.length}/255
                    </Typography>
                    {apiError && (
                        <Typography color="error" sx={{ mt: 2 }}>
                            {apiError}
                        </Typography>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDialogClose} color="secondary">
                        Cancel
                    </Button>
                    <Button onClick={handleCommentSubmit} color="primary" variant="contained" disabled={!newComment.trim()}>
                        Add Comment
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Edit Comment Dialog */}
            <Dialog open={editDialogOpen} onClose={handleEditDialogClose} maxWidth="sm" fullWidth>
                <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pr: 1 }}>
                    Edit Comment
                    <IconButton
                        aria-label="close"
                        onClick={handleEditDialogClose}
                        sx={{
                            color: (theme) => theme.palette.grey[500],
                            ml: 2,
                        }}
                        size="small"
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <Divider />
                <DialogContent>
                    {/* Recipient Dropdown */}
                    <FormControl fullWidth sx={{ mb: 2 }}>
                        <InputLabel id="edit-recipient-label">Recipient</InputLabel>
                        <Select
                            labelId="edit-recipient-label"
                            value={editRecipient}
                            label="Recipient"
                            onChange={handleEditRecipientChange}
                        >
                            <MenuItem value="everyone">Everyone</MenuItem>
                            {myBusinessUserList.map(user => (
                                <MenuItem key={user.userid} value={user.userid}>
                                    {user.username} ({user.rolename})
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <TextField
                        autoFocus
                        margin="dense"
                        label="Edit your comment"
                        type="text"
                        fullWidth
                        multiline
                        minRows={3}
                        value={editComment}
                        onChange={handleEditCommentChange}
                        inputProps={{ maxLength: 255 }}
                    />
                    <Typography variant="caption" color="text.secondary" sx={{ float: 'right', mt: 0.5 }}>
                        {editComment.length}/255
                    </Typography>
                    {editApiError && (
                        <Typography color="error" sx={{ mt: 2 }}>
                            {editApiError}
                        </Typography>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleEditDialogClose} color="secondary">
                        Cancel
                    </Button>
                    <Button onClick={handleEditCommentSave} color="primary" variant="contained" disabled={!editComment.trim()}>
                        Save
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Delete Comment Confirmation Dialog */}
            <Dialog open={deleteDialogOpen} onClose={handleDeleteDialogClose} maxWidth="xs" fullWidth>
                <DialogTitle>Delete Comment</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete this comment?
                    </DialogContentText>
                    <Box sx={{ backgroundColor: '#f5f5f5', borderRadius: 1, p: 2, mt: 2 }}>
                        <Typography variant="body2" color="text.primary">
                            {
                                sortedComments.find(c => c.id === deleteCommentId)?.title ||
                                sortedComments.find(c => c.id === deleteCommentId)?.comment ||
                                ""
                            }
                        </Typography>
                    </Box>
                    {deleteApiError && (
                        <Typography color="error" sx={{ mt: 2 }}>
                            {deleteApiError}
                        </Typography>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDeleteDialogClose} color="secondary">
                        Cancel
                    </Button>
                    <Button onClick={handleDeleteCommentConfirm} color="error" variant="contained">
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </Grid>
    );
}